import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {useParams} from 'react-router-dom'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export function VerifyUpdatedEmailPage1(){
    const [msg, setMsg] = useState('')
    const [data, setData] = useState('')
    const [otcBtn, setOtcBtn] = useState(false)
    const onChangeInput = ({ currentTarget: input }) => { setData({ ...data, [input.name]: input.value }) }
    const onClick2Verify =async() =>{
        setOtcBtn(true)
        setMsg('Please wait for 5 seconds...')
        const { data: res } = await axios.post(`${APIURL}/account-confirmation2`,data)
        setMsg(res.msg)
        setTimeout(() => {
            return window.location.replace('/login')
        }, 3000)
    }
    return(
        <div className='m-4  m-auto structure__verifyaccount__container'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Verification Page</h2>
        {/* This url is expired or url is wrong. Please check it again. */}
        <div className='m-auto flex flex-col w-fit justify-center'>
        <input name='confirmed' className='structure__login__input w-full md:w-96' onChange={onChangeInput} placeholder='verification code'/>
        <button className='primary-btn m-auto mt-1 mb-2 bitter' onClick={onClick2Verify} disabled={otcBtn}>Confirm your email</button>
        </div>
        <div className='m-auto text-center mb-4'>
        {msg}
        </div>
        </div>
    )
}
export function VerifyUpdatedEmailPage2(){
    const [msg, setMsg] = useState('')
    const [checkConfirmationNum, setcheckConfirmationNum] = useState(false)
    const [otcBtn, setOtcBtn] = useState(false)
    let params = useParams()
    useEffect(() => {
        if(!checkConfirmationNum){checkNumber()}
    })
    const checkNumber = async () => {
        try {
            const { data: res } = await axios.post(`${APIURL}/check-confirmation-number2`,{'confirmed':params.verificationcode})
            console.log(res.res)
            if(res.res===false){
                return window.location.replace('/404')
            }
            setcheckConfirmationNum(true)            
            return
        } catch (err) {
          console.error(err);
        }
    }
    const onClick2Verify =async() =>{
        setOtcBtn(true)
        setMsg('Please wait for 5 seconds...')
        const { data: res } = await axios.post(`${APIURL}/account-confirmation2`,{'confirmed':params.verificationcode})
        setMsg(res.msg)
        setTimeout(() => {
            return window.location.replace('/login')
        }, 3000)
    }
    return(
        <div className='m-4  m-auto structure__verifyaccount__container'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Verification Page</h2>
        {/* This url is expired or url is wrong. Please check it again. */}
        <div className='mt-1 flex w-full text-center'><button className='primary-btn m-auto mb-2 bitter' onClick={onClick2Verify} disabled={otcBtn}>Confirm your email</button></div>
        <div className='m-auto text-center mb-4'>
        {msg}
        </div>
        </div>
    )
}
